import { API_URL } from '../config';
import { ApiError, toApiError } from '../lib/api-error';

type OrgPropertyItem = {
  id: string;
};

export async function fetchOrgPropertyById<TProperty extends OrgPropertyItem>(
  propertyId: string
): Promise<TProperty> {
  const response = await fetch(`${API_URL}/org/properties/${encodeURIComponent(propertyId)}`, {
    credentials: 'include',
  });
  if (!response.ok) {
    throw await toApiError(response, 'Failed to fetch property');
  }

  const data = (await response.json()) as { property?: TProperty };
  const property = data.property;
  if (!property) {
    throw new ApiError({
      message: 'Application not found',
      status: 404,
      userError: true,
    });
  }

  return property;
}
